export default "__VITE_ASSET__BKIFUaP4__"